import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-light-action-type',
  templateUrl: './light-action-type.component.html',
  styleUrls: ['./light-action-type.component.less']
})
export class LightActionTypeComponent extends BaseRoutingComponent implements OnInit {

  constructor(
    protected router: Router,
    protected store: Store<any>,
  ) {
    super();
  }

  ngOnInit() {
  }


  isActive(path: string): boolean {
    let leaf = window.location.href.substring(window.location.href.lastIndexOf('/')+1);
    // console.log('light-action: leaf is', leaf);
    return (leaf === path);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/light-action-type/light-action-type.component.ts